import { useMemo } from "react";
import PropTypes from "prop-types";
import { Card } from "@mui/material";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import DataTable from "examples/Tables/DataTable";

function CorrectionHistoryTable({ selectedDevice, correctionHistoryData }) {
  const tableData = useMemo(() => {
    const columns = [
      { Header: "Date", accessor: "date" },
      { Header: "Time", accessor: "time" },
      { Header: "MILK", accessor: "milk" },
      { Header: "FAT", accessor: "fat" },
      { Header: "SNF", accessor: "snf" },
      { Header: "DEN", accessor: "den" },
      { Header: "PRO", accessor: "pro" },
      { Header: "LAC", accessor: "lac" },
      { Header: "SOL", accessor: "sol" },
      { Header: "TS", accessor: "ts" },
      { Header: "WATER", accessor: "water" },
      { Header: "FRPOINT", accessor: "frpoint" },
    ];
    const rows =
      correctionHistoryData?.map((record) => {
        return {
          date: record.Date,
          time: record.Time,
          milk: record.Milk || "N/A",
          fat: record.Fat || "N/A",
          snf: record.SNF || "N/A",
          den: record.Den || "N/A",
          pro: record.Pro || "N/A",
          lac: record.Lac || "N/A",
          sol: record.Sol || "N/A",
          ts: record.TS || "N/A",
          water: record.Water || "N/A",
          frpoint: record.FrPoint || "N/A",
        };
      }) || [];

    return { columns, rows };
  }, [correctionHistoryData, selectedDevice]);

  return (
    <Card>
      <MDBox
        mx={2}
        mt={-3}
        py={3}
        px={2}
        variant="gradient"
        bgColor="info"
        borderRadius="lg"
        coloredShadow="info"
      >
        <MDTypography variant="h6" color="white">
          Correction History for Device {selectedDevice}
        </MDTypography>
      </MDBox>
      <MDBox pt={3}>
        <DataTable
          table={tableData}
          isSorted={true}
          entriesPerPage={false}
          showTotalEntries={false}
          noEndBorder
        />
      </MDBox>
    </Card>
  );
}

CorrectionHistoryTable.propTypes = {
  selectedDevice: PropTypes.string.isRequired,
  correctionHistoryData: PropTypes.arrayOf(PropTypes.object),
};

export default CorrectionHistoryTable;
